// ============================================================================
// UKRAINIAN TRANSLATIONS - UNITY MODULE
// ============================================================================

export const unityTranslations = {
title: "Єдність, що Виробляє Мир",
    author: "Автор: Emmanuel",
    subtitle: "У кожної релігії є свої причини, наші кордони прийшли з минулого",
    description: "Модуль роздумів про духовну єдність і мир між традиціями",
    
    nav: {
      intro: "Вступ",
      religions: "Релігії",
      common: "Спільні Основи",
      humility: "Смиренність"
    },

    intro: {
      emmanuelSays: "Emmanuel каже:",
      ourBordersFromPast: "Наші кордони прийшли з минулого",
      bordersDescription: "У кожної релігії є свої причини. Наші поділи - не воля Божа, а плід історії, географії, культури.",
      divisionWork: "Поділ, ізоляція через бар'єри і кордони страху - це справа нашого небезпечного минулого.",
      sharedHumanity: "Ми народилися в різних традиціях, але поділяємо одну людяність.",
      
      revelationTitle: "Одкровення, що відкриває очі",
      surprisedLearning: "Я був здивований одного разу, дізнавшись, що євреї теж діти Божі.",
      angelMichael: "Що ангел Михаїл - великий посланець для мусульман.",
      jesusNames: "Що Ісус, Іса, Єшуа відомі по-різному, навіть у християнській вірі.",
      diverseTribes: "Тому що існують різні племена, різні церкви, різні сім'ї.",
      sameRealities: "Ми говоримо про одні й ті ж реальності різними іменами. Це повинно нас зближувати, а не розділяти.",
      
      respectTitle: "Повага: основа смиренності, страж миру",
      respectFoundation: "Навіть якщо братство об'єктивно незастосовне, повага - це основа смиренності, страж миру.",
      understandingProcess: "Розуміти і поважати інші релігії - це процес смиренності. Це не означає відмовлятися від своєї віри, але приймати, що інший теж шукає істину.",
      
      whatBindsUs: "Що справді нас зв'язує",
      seekingRelation: "Кожна релігія шукає відносин. Кожна людина шукає миру.",
      loveOfGod: "Ці відносини, що зв'язують нас усіх, - це любов Божа.",
      universalLink: "Любов - це універсальний зв'язок, який перевершує всі кордони, всі мови, всі традиції.",
      
      inclusionTitle: "Включення: ще більш обширне, ніж релігійне різноманіття",
      vastInclusion: "Релігійне різноманіття обширне, але ще більш обширне включення інших там, де вони покликані Богом.",
      respectDifferences: "Повага до відмінностей кольору, статі, включення робить нас унікальними людьми, улюбленими Богом.",
      jesusCommand: "Ісус сказав: 'Любіть одне одного.'",
      
      communitySpirit: "Порвати з духом громадськості",
      communityTerror: "Громадськість - це терор ненависті зла, замаскованого. Вона перетворює віру на племінну ідентичність, на стіну, що розділяє, на зброю, що ранить.",
      pridePolitics: "Наші партійні духи штовхають нас до політики гордині:",
      prideQuotes: "Я маю рацію, завдаючи тобі болю. Я маю рацію, і крапка. Я маю рацію, ведучи справедливу війну.",
      watchHeart: "Зверніть увагу на серце проблеми, на корінь нашого власного зла.",
      refuseDivision: "Відмовимося від цього дрейфу, який розділяє людство в ім'я Бога.",
      
      freedomTitle: "Щоб бути вільним, звільни інших",
      freedomOthers: "Щоб бути вільним, потрібно вміти звільняти й інших.",
      defendFreedom: "Моя свобода вірити має цінність лише якщо я захищаю свободу всіх. Гнобити іншого - означає приректи себе на рабство.",
      
      changeHeartTitle: "Зміни своє серце: будь справжнім ліхтарем",
      recognizeDecency: "Визнати, що пристойність не однакова для кожного.",
      changeYourself: "Зміна себе спочатку, поступово. Зміни своє серце, перетвори своє життя, будь справжнім ліхтарем.",
      beExample: "Не писай на траві, бо вона загине... Не нав'язуй свої правила іншим, але стань живим прикладом через свою трансформацію.",
      
      childrenPeaceTitle: "Наші діти житимуть у мирі в різноманітті",
      avoidPursuit: "Уникати переслідування слів за словами.",
      peaceChoice: "Якщо ми виберемо повагу сьогодні, наші діти майбутнього житимуть у мирі в різноманітті. Мир починається з нас, зараз, у наших словах і діях.",
      
      discernTitle: "Розрізняти: людина чи Бог?",
      manSpeaks: "Занадто часто говорить серце людини і розділяє.",
      seeFruits: "Це видно по плодах слів: крадіжка, руйнування, війни. Бережіться маніпуляції словами для своєї гордині.",
      
      lookPeaceTitle: "Дивитися на мир і любов",
      lookPeaceAll: "Дивитися на мир для всіх, дивитися на любов Бога до інших.",
      godSpeaks: "Коли слова виробляють мир, примирення, єдність: це Бог говорить. Коли вони виробляють поділ, ненависть, війну: це гординя людини.",
      
      watchWordsTitle: "Стежити за нашими словами",
      watchShares: "Стежити за нашими справами, стежити за нашими шкідливими словами проти інших.",
      disqualify: "Ці злодіяння дискваліфікують нас самих. Плоди наших слів розкривають, хто говорить у нас: Бог чи наша власна гординя?",
      
      wisdomMaturityTitle: "Мудрість і зрілість перед обличчям нашої природи",
      useScriptures: "Використовувати писання (закони) для заподіяння шкоди - наша звичка, майже природний і підступний процес.",
      hateSin: "Зіткнувшись з нашою грішною природою, ми ненавидимо зло і людей, які роблять зло.",
      separateActs: "Але мудрістю і зрілістю потрібно відокремити дії від нашої людської бідності.",
      compassionNature: "Визнати нашу тваринну природу, яка потребує співчуття і благодаті, захищаючись відповідно до контекстів.",
      
      denounceLeadersTitle: "Засудити корумпованих духовних лідерів",
      watchLeaders: "Бережіться духовних лідерів або керівників, які прагнуть зберегти в таємниці свій занепад і нечесність.",
      noJustice: "Без справедливості немає прикладу. Без знання інші жертви гинуть через наше мовчання.",
      silenceComplicity: "Мовчання перед обличчям несправедливості - це співучасть. Істина повинна бути сказана, щоб захистити інших."
    },

    religions: {
      title: "Різні Релігії, одне Людство",
      intro: "Християни, Мусульмани, Іудеї, Індуїсти, Буддисти... і багато інших: всі шукають істину",
      theirGod: "Їхній Бог:",
      theGood: "Добро:",
      theEvil: "Зло:",
      theAngels: "Ангели:",
      theUnity: "Єдність:",
      values: "Цінності:",
    commonGoal: "Спільна Мета",
    seekingPeace: "Всі релігії поділяють спільну мету: шукати мир, просувати любов і будувати кращий світ. Попри наші відмінності, ми всі об'єднані в цьому пошуку мудрості та гармонії.",
      
      christianity: {
        name: "Християнство",
        godText: "Єдиний Бог, Отець-творець",
        goodText: "Любов до ближнього, прощення, мир",
        evilText: "Ненависть, егоїзм, насильство",
        angelsText: "Посланці Бога (Гавриїл, Михаїл...)",
        unityText: "Один Бог для всіх людей",
        values: "Любов,Прощення,Мир,Смиренність,Справедливість"
      },
      islam: {
        name: "Іслам",
        godText: "Аллах, Єдиний і Милосердний",
        goodText: "Справедливість, милосердя, мир",
        evilText: "Гноблення, брехня, поділ",
        angelsText: "Ангели світла (Джібріль, Мікаїл...)",
        unityText: "Немає бога, крім Аллаха",
        values: "Мир,Справедливість,Милосердя,Повага,Милість"
      },
      judaism: {
        name: "Іудаїзм",
        godText: "ЯХВЕ, Вічний єдиний",
        goodText: "Справедливість, співчуття, життя",
        evilText: "Гноблення, наклеп, ненависть",
        angelsText: "Небесні посланці (Малахім)",
        unityText: "Слухай, Ізраїлю, Господь єдиний",
        values: "Справедливість,Життя,Пам'ять,Мир,Вчення"
      },
      hinduism: {
        name: "Індуїзм",
        godText: "Брахман, вища реальність",
        goodText: "Ненасильство (ахімса), праведний обов'язок",
        evilText: "Насильство, духовне невігластво",
        angelsText: "Дева, доброзичливі небесні істоти",
        unityText: "Все єдине в Брахмані",
        values: "Ненасильство,Істина,Співчуття,Чистота,Гармонія"
      },
      buddhism: {
        name: "Буддизм",
        godText: "Немає бога-творця, але повага до священного",
        goodText: "Співчуття, мудрість, мир",
        evilText: "Страждання, викликане невіглаством",
        angelsText: "Бодхісаттви, просвітлені істоти",
        unityText: "Природа Будди в кожному",
        values: "Співчуття,Мудрість,Мир,Ненасильство,Пробудження"
      }
    },

    common: {
      title: "Спільні Основи",
      intro: "Добро, Зло, Ангели, Єдиний Бог, Відносини, Включення: що об'єднує людство",
      
      goodTitle: "Добро",
      goodDescription: "Всі релігії навчають любові, справедливості і співчуттю",
      goodExamples: "Любити ближнього як самого себе|Робити добро без розрізнення|Захищати слабких і пригноблених|Говорити правду з добротою|Ділитися тим, що маєш",
      
      evilTitle: "Зло",
      evilDescription: "Всі засуджують насильство, брехню і гноблення",
      evilExamples: "Вбивати без справедливості|Красти і експлуатувати|Брехати і наклепати|Зневажати і принижувати|Розділяти і ненавидіти",
      
      angelsTitle: "Ангели і Духовні Істоти",
      angelsDescription: "Майже всі визнають доброзичливих небесних посланців",
      angelsExamples: "Ангели-посланці Бога|Духовні провідники|Істоти світла|Небесні захисники|Бодхісаттви і Дева",
      
      godTitle: "Єдиний Бог (або Вища Реальність)",
      godDescription: "Більшість вірить в єдине джерело, творця або кінцеву реальність",
      godExamples: "Християнство, Іслам, Іудаїзм: Єдиний Бог|Індуїзм: Брахман, вищий Єдиний|Буддизм: Універсальна природа Будди|Всі шукають кінцеву істину|Всі прагнуть до єдності і миру",
      
      relationTitle: "Відносини і Мир",
      relationDescription: "Що справді об'єднує всі релігії і всіх людей",
      relationExamples: "Кожна релігія шукає відносин з божественним|Кожна людина шукає миру|Ці відносини, що зв'язують нас усіх, - це любов Божа|Любов - це універсальний зв'язок|Мир - це наше спільне прагнення",
      
      inclusionTitle: "Включення: Улюблені Богом",
      inclusionDescription: "Релігійне різноманіття обширне, але ще більш обширне включення",
      inclusionExamples: "Включення інших там, де вони покликані Богом|Повага до відмінностей кольору|Повага до відмінностей статі|Включення робить нас унікальними людьми, улюбленими Богом|Ісус сказав: 'Любіть одне одного'",
      
      finalQuote: "Я був здивований одного разу, дізнавшись, що євреї теж діти Божі, що ангел Михаїл - великий посланець для мусульман, що Ісус, Іса, Єшуа відомі по-різному навіть у християнській вірі. Тому що існують різні племена, різні церкви, різні сім'ї.",
      finalQuote2: "Ми говоримо про одні й ті ж реальності різними іменами.",
      quoteAuthor: "Emmanuel, Єдність, що Виробляє Мир"
    },

    humility: {
      title: "7 Кроків до Смиренності і Миру",
      intro: "Процес подолання громадськості і становлення справжнім ліхтарем",
      
      step: "Крок",
      action: "Дія:",
      
      step1Title: "Визнати: наші кордони прийшли з минулого",
      step1Description: "Поділ, ізоляція через бар'єри і кордони страху - це справа нашого небезпечного минулого. Наші поділи - не воля Божа.",
      step1Action: "Прийняти, що моя традиція лише моя, і я частина різноманіття, бажаного Богом",
      
      step2Title: "Повага: основа смиренності, страж миру",
      step2Description: "Навіть якщо братство об'єктивно незастосовне, повага - це фундамент.",
      step2Action: "Поважати всі вірування, навіть не розуміючи всього",
      
      step3Title: "Розуміти без осуду",
      step3Description: "Сьогодні розуміння інших - це необхідний процес смиренності.",
      step3Action: "Справді слухати, у що вірять інші, без осуду",
      
      step4Title: "Зміна себе спочатку: будь справжнім ліхтарем",
      step4Description: "Визнати, що пристойність не однакова для кожного. Зміни своє серце поступово, перетвори своє життя, стань справжнім світлом.",
      step4Action: "Не нав'язувати свої правила іншим, але бути живим прикладом через свою трансформацію",
      
      step5Title: "Порвати з духом громадськості",
      step5Description: "Наші партійні духи штовхають нас до політики гордині: 'Я маю рацію, завдаючи тобі болю, я маю рацію, і крапка.' Зверніть увагу на серце проблеми, на корінь нашого власного зла.",
      step5Action: "Відмовитися від промов поділу в моїй власній громаді",
      
      step6Title: "Щоб бути вільним, звільни інших",
      step6Description: "Моя свобода залежить від тієї, що я даю іншим.",
      step6Action: "Захищати свободу совісті всіх, а не лише мою",
      
      step7Title: "Уникати переслідування слів за словами",
      step7Description: "Не відповідати ненавистю на ненависть, образами на образи.",
      step7Action: "Вибрати мир, щоб наші діти жили в мирі в різноманітті",
      
      discernFruits: "Розрізняти за Плодами",
      humanHeart: "Серце людини, яке розділяє",
      lookGodLove: "Дивитися на любов Бога",
      watchOurWords: "Стежити за нашими Словами",
      
      prideFruits: "Плоди людської гордині",
      prideFruitsList: "Дух партійності: \"Я маю рацію, крапка\"|Політика гордині: \"Я маю рацію завдавати тобі болю\"|Використання писань для заподіяння шкоди (підступний процесс)|Ненависть до людей (а не лише до вчинків)|Духовні лідери, що приховують свою відхиленість і нечесність|Мовчазне співучасть перед обличчям несправедливості|Поділ і війни|Ненависть, замаскована під благочестя|Крадіжка і руйнування|Маніпуляція заради гордині|Зневага і насильство",
      
      godFruits: "Плоди любові Бога",
      godFruitsList: "Розділення вчинків і особистості з мудрістю|Співчуття до нашої людської бідності|Благодать, захищаючи себе відповідно до контексту|Викриття несправедливості для захисту інших|Говоріння правди з мужністю|Мир для всіх|Любов без розрізнення|Примирення і єдність|Смирення і повага|Свобода для всіх",
      
      finalQuote: "Навіть якщо братство об'єктивно незастосовне, повага - це основа смиренності, страж миру. Уникати переслідування слів за словами, і наші діти майбутнього житимуть у мирі в різноманітті.",
      author: "Emmanuel"
    },

    footer: {
      quote: "Повага - це основа смиренності, страж миру. Наші діти житимуть у мирі в різноманітті, якщо ми виберемо повагу сьогодні.",
      author: "Emmanuel, Єдність, що Виробляє Мир"
    }
};

export default unityTranslations;
